import { render, staticRenderFns } from "./CaseCategory.vue?vue&type=template&id=271bcdf2"
import script from "./CaseCategory.vue?vue&type=script&lang=js"
export * from "./CaseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports